module.exports = __webpack_public_path__ + "img/vippack_cod_k.f314b56e.png";